/**
 * This mixin adds options to the table that the use can change,
 * notable hiding/showing columns
 */
export default {
  props: {
    items: {
      type: Array,
      default() {
        return [];
      },
    },
    tableOptions: {
      type: Boolean,
    },
    initialHiddenHeaders: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      tableOptionsDialog: false,
      userHiddenHeaders: [],
      openDialog: false,
    };
  },
  mounted() {
    this.userHiddenHeaders.push(...this.initialHiddenHeaders);
  },
  methods: {
    isUserHiddenHeader(headerKey) {
      return this.userHiddenHeaders.includes(headerKey);
    },
    showOrHideHeader(header, allColumns) {
      const index = this.userHiddenHeaders.indexOf(header.value);
      let visibleColumns = allColumns.filter(
        (v) => !this.userHiddenHeaders.includes(v.value)
      );
      if (index === -1) {
        if (
          visibleColumns.length == 1 &&
          visibleColumns[0].value == header.value
        ) {
          this.openDialog = true;
        } else {
          this.userHiddenHeaders.push(header.value);
        }
      } else {
        this.userHiddenHeaders.splice(index, 1);
      }
    },
    updateDynamicHeader() {
      //hide and show the header based on the updated value
      for (var i = 0; i < this.initialHiddenHeaders.length; i++) {
        if (!this.isUserHiddenHeader(this.initialHiddenHeaders[i])) {
          this.userHiddenHeaders.push(this.initialHiddenHeaders[i]);
        }
      }
    },
  },
};
